module.exports = {
  en: {
    beebee: {
      slogan: 'Get the most from your work and dedicate more time to your customers',
      trynow: 'Try Now'
    },
    label: {
      username: 'Username',
      password: 'Password',
      secure_code: 'Codice di sicurezza',
      login: 'Log in',
      loginGoogle: 'Log in with Google',
      forgotPassword: 'Forgot password?',
      notHaveAccount: 'Don\'t have an account?',
      signUp: 'Sign up',
      mailSent: 'Mail sent',
      checkMailRecover: 'Check you inbox to recover your password',
      enterMailToSendInstro: 'We\'ll emai your instructions on how to reset you password',
      recoverPassword: 'Recover password',
      backLogin: 'Back to login',
      passwordNotMatch: 'Password not match',
      recoverPasswordError: 'Recover password error',
      signupError: 'Sign up error',
      resetError: 'Reset error',
      signupGoogle: 'Sign up with Google',
      or: 'OR',
      name: 'Name',
      confirmPassword: 'Confirm password',
      newPassword: 'New Password',
      continue: 'Continue',
      emptyField: 'Empty field',
      invalidMail: 'Invalid mail',
      invalidUsername: 'Invalid username, you can only use lowercase letters and numbers',
      emailVerification: 'Email verification',
      emailVerificationSuccess: 'Your email was verified. You can continue using Beebeeboard.',
      emailVerificationError: 'Your email was not verified. You can not continue using the application.',
      passwordChanged: 'Password changed',
      loginAt: 'Login at',
      resetPassword: 'Reset password',
      registrationCompleted: 'Registration completed',
      invalidSession: 'Invalid session',
      lessThenMinute: 'It takes less than a minute',
      alreadyAccount: 'If you already have an account',
      personalInfo: 'Personal informations',
      accountInfo: 'Account informations',
      changePassword: 'Change password',
      termsOfServices: 'Terms of services',
      privacyPolicy: 'Privacy policy',
      beebeeGDPR: 'We use Beebeeboard as our platform. By clicking to register from this page, you acknowledge that the information you provide will be transferred to Beebeeboard for processing in accordance with their',
      noActive: 'Organization not activated',
      resendActivatedMail: 'if you don\'t have received the registration mail we can send it to you again',
      resendActivatedMailButton: 'Send me a new mail',
      errorResendMail: 'Error sending mail',
      first_name: 'First name',
      last_name: 'Last name'
    }
  },
  it: {
    beebee: {
      slogan: 'Organizza il tuo lavoro e dedica più tempo ai tuoi clienti',
      trynow: 'Provalo subito'
    },
    label: {
      username: 'Nome utente',
      password: 'Password',
      login: 'Accedi',
      loginGoogle: 'Accedi con Google',
      forgotPassword: 'Recupera password?',
      notHaveAccount: 'Non hai un account?',
      signUp: 'Registrati',
      mailSent: 'Mail inviata',
      checkMailRecover: 'Controlla la tua mail per ripristinare la password',
      enterMailToSendInstro: 'Ti invieremo una mail con le istruzioni per reimpostare la tua password',
      recoverPassword: 'Ripristina password',
      backLogin: 'Torna al login',
      passwordNotMatch: 'Le Password non coincidono',
      recoverPasswordError: 'Errore nel recupero password',
      signupError: 'Error nella registrazione',
      resetError: 'Errore nel recupero password',
      signupGoogle: 'Registrati con Google',
      or: 'OPPURE',
      name: 'Nome',
      confirmPassword: 'Conferma password',
      newPassword: 'Nuova password',
      continue: 'Successivo',
      emptyField: 'Campi mancanti',
      invalidMail: 'Mail non valida',
      invalidUsername: 'Nome utente non valido, puoi usare solo lettere minuscole e numeri',
      emailVerification: 'Verifica mail',
      emailVerificationSuccess: 'La mail è stata verificata. Puoi continuare ad usare Beebeeboard.',
      emailVerificationError: 'La mail non è stata verificata. Non puoi continuare ad usare Beebeeboard.',
      passwordChanged: 'Password modificata',
      loginAt: 'Accedi subito',
      resetPassword: 'Recupera password',
      registrationCompleted: 'Registrazione completata',
      invalidSession: 'Sessione non valida',
      lessThenMinute: 'Ci vuole meno di un minuto',
      alreadyAccount: 'Se hai già un account',
      personalInfo: 'Informazioni personali',
      accountInfo: 'Informazioni sull\'account',
      changePassword: 'Cambia password',
      termsOfServices: 'Termini e condizioni',
      privacyPolicy: 'Normativa privacy',
      beebeeGDPR: 'Usiamo Beebeeboard come piattaforma di elaborazione dati. Facendo click per registrarti da questa pagina, acconsenti che le tue informazioni vengano trasferite a Beebeeboard per la loro elaborazione in conformità con la loro',
      noActive: 'Organizzazione non attiva',
      resendActivatedMail: 'Se non hai ricevuto la mail per completare la registrazione possiamo inviartela nuovamente',
      resendActivatedMailButton: 'Inviami una nuova mail',
      errorResendMail: 'Errore nell\'inviare la mail',
      first_name: 'Nome',
      last_name: 'Cognome'
    }
  }
}



// WEBPACK FOOTER //
// ./src/locale.js